"use client";

import SolarLocationPage from "@/components/locations/solar-location-page";
import { getLocationLandingConfig } from "@/data/location-pages";

const config = getLocationLandingConfig("andalucia");

export default function PlacasSolaresAndaluciaPage({ locale }: { locale: string }) {
  return <SolarLocationPage locale={locale} id="andalucia" config={config} />;
}
